import { BannerProps, PredefinedBanner } from './types'
import { PredefinedBanners } from './PredefinedBanners'
import { useTranslation } from 'next-i18next'
import { PHONE_NOT_REACHABLE } from 'constants/constants'
import { useStoreSelector } from 'hooks/store'
import { SIMULATION_DOWN } from 'constants/envs'
import { Flag } from '@boltenergy-be/design-system'

export const Banner = ({ onClick }: BannerProps) => {
  // REDUX STORE
  const { banner, bannerType } = useStoreSelector((store) => store.marketing)

  // i18n
  const { t } = useTranslation('common')

  // Constants
  const showDefaultBanner = false // set to: pathname === '/' for banner on homepage
  const showBanner = banner || bannerType || showDefaultBanner || PHONE_NOT_REACHABLE || SIMULATION_DOWN

  /**
   * Returns the predefined banner based on the marketing state values
   */
  const getPredefinedBanner = (): PredefinedBanner | null => {
    if (SIMULATION_DOWN) return PredefinedBanners.simulationDown

    if (bannerType) return PredefinedBanners[bannerType]

    return null
  }

  const predefinedBanner = getPredefinedBanner()

  return (
    showBanner && (
      <div onClick={onClick}>
        <Flag
          type={predefinedBanner?.type || 'attention'}
          title={
            predefinedBanner
              ? t(predefinedBanner.titleNsAndKey)
              : PHONE_NOT_REACHABLE
                ? t('phoneNotReachable')
                : showDefaultBanner
                  ? t('defaultBanner')
                  : banner
          }
        >
          {predefinedBanner ? t(predefinedBanner.descriptionNsAndKey) : undefined}
        </Flag>
      </div>
    )
  )
}

export default Banner
